import { Component, ViewEncapsulation, input } from '@angular/core';

import { EmailMailgunHtmlComponent } from '../../components/email-html/email-mailgun-html.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailImageAssetDirective } from '../../directives/email-image-asset.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  styleUrls: ['./user-email.component.less'],
  templateUrl: './user-email.component.html',
  imports: [
    EmailTextComponent,
    EmailMailgunHtmlComponent,
    EmailImageAssetDirective,
    MailgunMarkAsHtmlPipe,
    EmailMarginComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class UserEmailTemplateComponent {
  public readonly data = input.required<WrappedValue<UserEmailTemplateData>>();
}

export type UserEmailTemplateData = {
  content: string;
  footer: {
    prefix: string;
    suffix: string;
  };
};

export const UserEmailTemplateMocks: UserEmailTemplateData[] = [
  {
    content: `<span>Email content goes here. This is a placeholder for the actual email content that will be sent to the user. It can include text, links, and other HTML elements as needed.</span>`,
    footer: {
      prefix: 'This email was sent via',
      suffix: '– the collaborative hiring software ',
    },
  },
];
